// playmute - video without voice
// playunmute - video with voice
class StoriesList {
  constructor () {
    this.screen = null;
    this.mainSlider = null;
    this.videos = null;
    this.activeVideo = 0;
    this.slideScreen = null;
    this.autoPlay = false;
    this.isWait = false;
    this.timer = null;
    this.statusVideo = "playmute";
    this.initSliders();
  }

  initSliders () {
    this.videos = document.querySelectorAll(".js-stories-list .js-video");
    this.initVarible();
    this.initMainSlider();
    this.initEventEnded();
    this.initEventClick();
    this.scrollVideo();
  }

  initVarible () {
    this.setScreenSlide();
  }

  initMainSlider () {
    const _this = this;
    this.mainSlider = new Swiper(".js-stories-list", {
      autoHeight: true,
      pagination: {
        el: document.querySelector(".js-stories-list-bullets"),
        type: "bullets",
        clickable: true,
        autoHeight: true,
        watchActiveIndex: true,
        bulletActiveClass: "stories-bullets--active",
        bulletClass: "stories-bullets__item",
        renderBullet: function (index, className) {
          return "<span class=\"" + className + "\" ><span class=\"stories-bullets__dot\">" + "</span></span>";
        }
      },
      breakpoints: {
        0: {
          spaceBetween: 12,
          slidesPerView: 1.5
        },
        560: {
          spaceBetween: 12,
          slidesPerView: 2.5
        },
        768: {
          spaceBetween: 12,
          slidesPerView: 3
        },
        1024: {
          spaceBetween: 30,
          slidesPerView: 3
        }
      }
    });
  }

  initEventEnded () {
    this.videos.forEach(videoBox => {
      const video = videoBox.querySelector("video");
      video.addEventListener("ended", (event) => {
        this.activeVideo++;
        const video = this.videos[this.activeVideo];
        if (!video) return;
        this.playNextVideo(this.videos[this.activeVideo]);
      });
    });
  }

  getScreenSlide () {
    if (window.innerWidth >= 768) return 3;
    if (window.innerWidth >= 560 && window.innerWidth <= 768) return 2;
    if (window.innerWidth < 560) return 1;
  }

  setScreenSlide () {
    const screenCol = this.getScreenSlide();
    if (screenCol !== this.slideScreen) {
      this.slideScreen = screenCol;
    }
  }

  stopPrevVideo (video) {
    if (video) {
      const videoTag = video.closest(".js-video").querySelector("video");
      videoTag.muted = true;
      videoTag.pause();
      video.classList.replace("play", "stop");
    }
  }

  playNextVideo (video) {
    if (video) {
      this.playActiveVideo(video);
      if (this.statusVideo == "playunmute") {
        const video = this.videos[this.activeVideo]
        video.querySelector('video').muted = false;
        video.querySelector(".js-video-action").classList.replace("stop", "play");
      }
      if (this.activeVideo - this.mainSlider.activeIndex >= this.slideScreen) this.mainSlider.slideTo(this.activeVideo);
    }
  }

  playActiveVideo (video, clearTime) {
    const videoTag = video.querySelector("video");
    videoTag.setAttribute("autoplay", true);
    videoTag.play();
    if (clearTime) videoTag.currentTime = 0;
  }

  initEventClick () {
    this.videos.forEach(video => {
      video.addEventListener("click", (event) => {
        const isPlay = video.querySelector(".js-video-action").classList.contains("play");
        const id = video.closest(".swiper-slide").dataset.id * 1;
        if (this.statusVideo == "playmute") {
          video.muted = false;
          this.statusVideo = "playunmute";
        }

        if (isPlay && (this.activeVideo !== id)) {
          this.stopPrevVideo(this.videos[this.activeVideo]);
          this.playActiveVideo(video, true);
          this.activeVideo = video.closest(".swiper-slide").dataset.id * 1;
        }
        if ((this.activeVideo - this.mainSlider.activeIndex) >= this.slideScreen) this.mainSlider.slideTo(this.activeVideo);
      });
    });
  }

  scrollVideo () {
    document.addEventListener("scroll", () => {
      if (this.isWait) clearTimeout(this.timer);
      this.isWait = true;
      this.timer = setTimeout(() => {
        this.checkIsVisible();
        this.isWait = false;
      }, 200);
    });
  }

  checkIsVisible () {
    const elementRect = document.querySelector(".js-stories-list .swiper-wrapper");
    const rect = elementRect.getBoundingClientRect();
    const isVisible = (rect.top >= 0) && (rect.bottom <= window.innerHeight);
    if (isVisible && !this.autoPlay) {
      this.autoPlay = true;
      this.playActiveVideo(this.videos[this.activeVideo]);
    }
    if (!isVisible && this.autoPlay) {
      this.statusVideo = "playmute"
      this.autoPlay = false;
      const video = this.videos[this.activeVideo];
      video.querySelector('video').muted = true;
      video.querySelector(".js-video-action").classList.replace("play", "stop");
      this.stopPrevVideo(video);
    }
  }

}

document.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => {
    new StoriesList();
  }, 100);
});
